<div class="sidebar-root">
  <div class="sidebar-brand">
    <a routerLink="/" class="sidebar-brand-link" aria-label="Walley - Vai alla home">
      <span class="sidebar-brand__title">Walley</span><span class="sidebar-brand__tag"> - ERP</span>
    </a>
  </div>
  <nav class="sidebar-nav sidebar-scroll" style="font-size: 15px" #div_menu aria-label="Menu principale"></nav>
</div>
